import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { DISTRIBUSION_DEFAULT_LOGO, DISTRIBUSION_SMALL_LOGO } from 'constants/common';

import './logo-link.less';

interface LogoLinkProps {
  to: string;
  collapsed?: boolean;
  baseLogoUrl?: string;
  secondLogoUrl?: string;
}

export const LogoLink = ({ to, collapsed, baseLogoUrl, secondLogoUrl }: LogoLinkProps) => {
  const baseImgUrl = baseLogoUrl || DISTRIBUSION_DEFAULT_LOGO;
  const secondImgUrl = secondLogoUrl || DISTRIBUSION_SMALL_LOGO;
  return (
    <Link className={classNames('logo-link', { 'logo-link--collapsed': collapsed })} to={to}>
      <img className="logo" src={collapsed ? secondImgUrl : baseImgUrl} />
    </Link>
  );
};
